"use client";

import { TextShimmer } from "@/components/text-shimmer";

import { SlidingNumber } from "@/components/sliding-number";
import { useAppSelector } from "@/redux/hooks";
import { FilterXIcon, Loader } from "lucide-react";
import FilterDisplayPopover from "./filter-popover";
import { FilterSection } from "./flight-filter";
import { FlightSearchTimer } from "./flight-search-timer";

export default function FlightSearchSidebar({ total }: { total?: number }) {
  const { isLoading, error, isResponseEnd } = useAppSelector(
    (state) => state.flightSearchStatus,
  );

  return (
    <div className="sticky top-[calc(var(--header-height)+4rem)] z-30 lg:flex lg:h-[calc(100svh-var(--header-height)-4.1rem)] w-full self-start overscroll-none   lg:w-[28%] ">
      <div className="hidden lg:flex lg:flex-col w-full">
        <div className="  border border-t-0! z-20  bg-background  pt-3  rounded-b-lg">
          <div className="flex justify-between items-end pl-4 pr-2 py-1 ">
            <div>
              <span className="font-bold text-xs md:text-lg">
                {isLoading ? (
                  <TextShimmer>Searching flights...</TextShimmer>
                ) : !isResponseEnd ? (
                  !error ? (
                    <TextShimmer>Loading more ...</TextShimmer>
                  ) : null
                ) : (
                  "Flight Search"
                )}
              </span>
              <div className="text-xs text-muted-foreground flex gap-1">
                {isLoading ? (
                  <Loader className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
                ) : error ? (
                  0
                ) : (
                  <div className="inline-flex items-center font-bold italic text-destructive">
                    <SlidingNumber value={total ?? 0} updateDelayMs={100} />
                  </div>
                )}
                <span>flights found</span>
              </div>
            </div>

            <FlightSearchTimer />
          </div>
        </div>

        <div className="bg-background mt-3 rounded-t-lg border h-full  overflow-auto no-scrollbar">
          <div className="flex items-center justify-between gap-2 pl-4 py-2 sticky top-0 z-20 bg-background border-b">
            <div className="flex items-center gap-2">
              <FilterXIcon className="h-3.5 w-3.5 text-muted-foreground" />
              <span className=" font-semibold ">Filters</span>
            </div>

            <FilterDisplayPopover />
          </div>
          <FilterSection />
        </div>
      </div>
    </div>
  );
}
